export enum ItemGainOnOptions {
    Null = '',
    Grant = 'grant',
    Equip = 'equip',
    Use = 'use',
    Rest = 'rest',
}
